import React from 'react';
import { Icon } from '@vectord/components';

import { EDIT_CRASH_COURSE_BATCH_DISCLAIMER } from 'features/classCreation';

function DisclaimerDetails() {
  return (
    <div className="m-v-xs">
      <Icon
        name="info"
        className="m-r-xxs"
      />
      Disclaimer
      <div className="m-l-s m-t-xxs">
        {EDIT_CRASH_COURSE_BATCH_DISCLAIMER.map((data) => (
          <li key={data}>{data}</li>
        ))}
      </div>
    </div>
  );
}

export default DisclaimerDetails;
